import React from 'react';
import { Link } from 'react-router-dom';

function PageHero({ title, sub }) {
  return (
    <div className="page-hero">
      <div className="page-hero-bg"/>
      <div className="container">
        <span className="section-tag">Our Story</span>
        <h1 className="page-hero-title">{title}</h1>
        <p className="page-hero-sub">{sub}</p>
      </div>
    </div>
  );
}

const values = [
  { icon:'🎯', title:'Precision', desc:'Treatment is centered on careful diagnosis, 3D-guided planning, and focused surgical care for predictable outcomes.' },
  { icon:'❤️', title:'Compassion', desc:'Every patient is treated with a calm, respectful approach — from consultation through recovery.' },
  { icon:'💡', title:'Modern Technology', desc:'Laser dentistry, CBCT scanning, and digital smile design for the most advanced treatment available.' },
  { icon:'🤝', title:'Affordable Excellence', desc:'Safe, effective and affordable care that delivers long-lasting results without compromise.' },
];

const milestones = [
  { year:'BDS', event:'Dr. Sangeeta Arvind completed her Bachelor of Dental Surgery training.' },
  { year:'MDS', event:'She went on to specialise in Oral Surgery through her Master of Dental Surgery qualification.' },
  { year:'IMP', event:'Advanced implantology training is listed from Sawangi, Wardha.' },
  { year:'CLF', event:'Cleft specialist training is listed from Raipur.' },
  { year:'GKP', event:'Dant Sanjeevani serves patients from its clinic near AIIMS Gate No. 4, Gorakhpur.' },
];

export default function About() {
  return (
    <>
      <PageHero title={<>About <em>Dant Sanjeevani</em></>} sub="One of the best dental clinics in Gorakhpur — trusted for expert care, modern facilities and long-lasting results." />

      {/* Intro */}
      <section className="section">
        <div className="container">
          <div className="about-intro-grid">
            <div className="about-img-col reveal">
                <div className="about-img-stack">
                  <div className="ais-main">
                  <img src="/hero.png" alt="Dant Sanjeevani clinic" />
                </div>
                <div className="ais-badge">
                  <span className="ais-num">MDS</span>
                  <span className="ais-label">Oral Surgery</span>
                </div>
              </div>
            </div>
            <div className="about-text-col reveal" style={{'--delay':'0.2s'}}>
              <span className="section-tag">About Dant Sanjeevani</span>
              <h2 className="section-title">Expert Care by <em>Dr. Sangeeta Arvind</em></h2>
              <p>Welcome to Dant Sanjeevani, recognised as one of the best dental clinics in Gorakhpur, conveniently located at AIIMS Gate No. 4, Kunraghat &mdash; trusted for expert care and modern facilities.</p>
              <p>Dant Sanjeevani is led by <strong>Dr. Sangeeta Arvind &mdash; BDS, MDS (Oral & Maxillofacial Surgery), Cleft Specialist, Implantologist.</strong> She provides advanced cosmetic & restorative dentistry, dental implants, crowns, braces, teeth whitening, porcelain veneers, smile makeovers, cleft surgery, TMJ surgery, jaw fracture treatment, and laser treatment &mdash; delivering safe, effective, affordable and long-lasting results.</p>
              <div className="about-features">
                {['BDS, MDS (Oral & Maxillofacial Surgery)','Cleft Specialist & Implantologist','Advanced Cosmetic & Restorative Dentistry','Dental Implants (All-on-4, All-on-6, Zygomatic, Same-Day)','Laser Dentistry & 3D Guided Surgery','Located at AIIMS Gate No. 4, Gorakhpur'].map((f, i) => (
                  <div key={i} className="af-item"><span className="feature-check">✓</span><span>{f}</span></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section" style={{paddingTop:0}}>
        <div className="container">
          <div className="section-header reveal">
            <span className="section-tag">Our Core Values</span>
            <h2 className="section-title">What Guides the <em>Clinic</em></h2>
          </div>
          <div className="values-grid">
            {values.map((v, i) => (
              <div key={i} className="value-card reveal" style={{'--delay': `${i * 0.1}s`}}>
                <div className="value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="section timeline-section">
        <div className="container">
          <div className="section-header reveal">
            <span className="section-tag">Professional Snapshot</span>
            <h2 className="section-title">Credentials and <em>Focus Areas</em></h2>
          </div>
          <div className="timeline">
            {milestones.map((m, i) => (
              <div key={i} className={`timeline-item${i % 2 === 0 ? ' left' : ' right'} reveal`} style={{'--delay': `${i * 0.1}s`}}>
                <div className="timeline-dot"/>
                <div className="timeline-card">
                  <span className="timeline-year">{m.year}</span>
                  <p>{m.event}</p>
                </div>
              </div>
            ))}
            <div className="timeline-line"/>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section" style={{paddingTop:0}}>
        <div className="container">
          <div className="cta-inner reveal">
            <div className="cta-text">
              <h2>Ready for Your Best Smile?</h2>
              <p>Visit Dant Sanjeevani at AIIMS Gate No. 4, Kunraghat, Gorakhpur — or book a consultation with Dr. Sangeeta Arvind today.</p>
            </div>
            <Link to="/contact" className="btn-primary btn-lg">Contact the Clinic →</Link>
          </div>
        </div>
      </section>
    </>
  );
}
